import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { AwsCredentialIdentityProvider } from '@smithy/types';
import { fetchAuthSession } from 'aws-amplify/auth';
import { S3 } from '@aws-sdk/client-s3';
import { authConfig } from '../config/runtimeConfig';

export class S3BrowserAccessService {
    private credentialsProvider?: AwsCredentialIdentityProvider;

    private async buildCredentialsProvider(): Promise<AwsCredentialIdentityProvider> {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        if (!idToken) {
            throw new Error('Cannot create S3 browser credentials without an authenticated session.');
        }
        const cognitoId = `cognito-idp.${authConfig.aws_cognito_region}.amazonaws.com/${authConfig.aws_user_pools_id}`;

        return fromCognitoIdentityPool({
            clientConfig: { region: authConfig.aws_cognito_region },
            identityPoolId: authConfig.aws_cognito_identity_pool_id,
            logins: {
                [cognitoId]: idToken,
            },
        });
    }

    public async getCredentialsProvider(): Promise<AwsCredentialIdentityProvider> {
        if (!this.credentialsProvider) {
            this.credentialsProvider = await this.buildCredentialsProvider();
        }

        return this.credentialsProvider;
    }

    public async createS3Client(): Promise<S3> {
        return new S3({
            region: authConfig.aws_cognito_region,
            credentials: await this.getCredentialsProvider(),
        });
    }
}